import React, { useEffect, useState } from "react";
import { Tray, ShieldCheck, ShieldWarning } from "@phosphor-icons/react";
import api from "@/lib/api";

export function fmtWhen(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}

function InboxMessage({ m, testId }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-black bg-white" data-testid={testId}>
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full text-left px-2 py-1.5 flex items-center gap-2 flex-wrap text-[11px] hover:bg-zinc-50">
        <span className="font-mono text-zinc-500">{fmtWhen(m.received_at)}</span>
        <span className="font-bold">{m.name || "—"}</span>
        <span className="text-zinc-600">{m.state || ""}</span>
        {m.is_test_lead && <span className="border border-black bg-amber-200 px-1 text-[9px] uppercase tracking-widest">Test</span>}
        <span className={`ml-auto inline-flex items-center gap-1 text-[10px] ${m.signature_ok ? "text-emerald-700" : "text-red-700"}`}>
          {m.signature_ok ? <ShieldCheck size={12} weight="bold" /> : <ShieldWarning size={12} weight="bold" />}
          {m.signature_ok ? "Signature OK" : "Signature missing/invalid"}
        </span>
      </button>
      {open && (
        <pre className="border-t border-black bg-zinc-50 p-2 text-[10px] max-h-64 overflow-y-auto whitespace-pre-wrap break-all" data-testid={`${testId}-payload`}>
          {JSON.stringify(m.payload, null, 2)}
        </pre>
      )}
    </div>
  );
}

export const TestInboxViewer = ({ pageId, code, refreshKey }) => {
  const [state, setState] = useState({ data: null, err: "" });
  useEffect(() => {
    let alive = true;
    api.get(`/admin/test-inbox/${pageId}`)
      .then((r) => { if (alive) setState({ data: r.data, err: "" }); })
      .catch((e) => { if (alive) setState({ data: null, err: e?.response?.data?.detail || "Couldn't load the test inbox" }); });
    return () => { alive = false; };
  }, [pageId, refreshKey]);
  const msgs = state.data?.messages || [];
  return (
    <div className="border-2 border-black bg-zinc-50 p-3" data-testid={`test-inbox-${code}`}>
      <div className="flex items-center gap-2 mb-2">
        <Tray size={14} weight="bold" />
        <div className="font-bold uppercase tracking-widest text-[10px]">Built-in test inbox</div>
        <div className="label-mono text-zinc-600" data-testid={`test-inbox-${code}-count`}>
          {state.data ? `${state.data.total} received · newest first` : ""}
        </div>
      </div>
      {state.err && <div className="text-[11px] text-red-700" data-testid={`test-inbox-${code}-error`}>{state.err}</div>}
      {!state.err && !state.data && <div className="label-mono">Loading…</div>}
      {state.data && !msgs.length && (
        <div className="label-mono text-zinc-500" data-testid={`test-inbox-${code}-empty`}>Nothing received yet — send a test lead.</div>
      )}
      <div className="flex flex-col gap-1.5">
        {msgs.map((m, i) => <InboxMessage key={m.id} m={m} testId={`test-inbox-${code}-msg-${i}`} />)}
      </div>
    </div>
  );
};
